
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicShopCartApi extends BaseModulePublicApi {
  basePath = 'shop/cart';
};
